import React from 'react';
import displayName from 'component-lib/displayName';

// TODO: remove inline styles
const styles = {
    display: 'inline-block',
    width: '30px',
};

export default function ButtonSpacer() {
    return (
        <span style={{ ...styles }} />
    );
}

ButtonSpacer.displayName = displayName('Dialog/ButtonSpacer');
